import { createSelector } from '@reduxjs/toolkit';

import { DocumentGeneric } from 'dashboard/models/document';
import { RootState } from 'dashboard/redux/store';
import { ApiModel } from 'lib/interfaces/api';

const getAccountDocuments = (state: RootState) => state.account.documents;

export const getAccountGenericDocuments = createSelector(
  [getAccountDocuments],
  (documents = []) =>
    documents.filter((document) => document.type === ApiModel.DocumentGeneric) as DocumentGeneric[],
);
